export const gmoEndpoints = {
	mpToken: {
		TEST: "https://stg.static.mul-pay.jp/payment/js/mp-token.js",
		PRODUCTION: "https://static.mul-pay.jp/payment/js/mp-token.js"
	}
};
